module.exports = __webpack_public_path__ + "static/media/cart-none.db23dba4.png";